module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pageHeader'), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "body-width"
  }, [_c('b-row', [_c('b-col', [_c('h1', {
    staticClass: "setting__title"
  }, [_vm._v("設定")])])], 1), _vm._v(" "), _c('b-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('b-col', {
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "setting__container"
  }, [_c('b-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('b-col', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "category-setting__title"
  }, [_vm._v("カテゴリ")])])], 1), _vm._v(" "), _c('b-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('b-col', {
    staticClass: "category-setting-list",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "md": "3"
    }
  }, [_c('ul', {
    staticClass: "category-setting-list__list"
  }, _vm._l((_vm.categorys), function(category, index) {
    return _c('li', {
      key: category.id,
      staticClass: "category-setting-list__row",
      class: _vm.selectRow(category.id),
      attrs: {
        "tabindex": "0",
        "id": ("category-" + index)
      },
      on: {
        "click": function($event) {
          return _vm.selectCategory(category.id)
        },
        "!keydown": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
        },
        "keydown": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.selectCategory(category.id)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
          return _vm.changeFocusByUpKey(_vm.categorys, index)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
          return _vm.changeFocusByDownKey(_vm.categorys, index)
        }]
      }
    }, [_vm._v("\n                    " + _vm._s(category.name) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('b-col', {
    staticClass: "category-setting-container",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('ul', {
    staticClass: "category-setting__option"
  }, _vm._l((_vm.categoryOptionList), function(option, i) {
    return _c('li', {
      key: i,
      staticClass: "category-setting__option-item"
    }, [_c('b-row', {
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('b-col', {
      staticClass: "category-setting__value-title",
      staticStyle: {
        "padding": "5px 0px"
      },
      attrs: {
        "md": "8"
      }
    }, [_vm._v("\n                        " + _vm._s(option.title) + "\n                      ")]), _vm._v(" "), (option.selectbox == 1) ? [_c('b-col', {
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCategoryOptions[i]),
        expression: "selectedCategoryOptions[i]"
      }],
      staticClass: "category-setting__select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.selectedCategoryOptions, i, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((option.values), function(value, j) {
      return _c('option', {
        key: j,
        domProps: {
          "value": value
        }
      }, [_vm._v("\n                              " + _vm._s(value) + "\n                            ")])
    }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.unit))])])] : [_c('b-col', {
      staticClass: "category-setting__value",
      staticStyle: {
        "padding": "0px"
      },
      attrs: {
        "md": "2"
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.selectedCategoryOptions[i]) + "\n                        ")]), _vm._v(" "), _c('b-col', {
      staticStyle: {
        "padding": "5px 0px"
      }
    }, [_vm._v("\n                          " + _vm._s(option.unit) + "\n                        ")])]], 2)], 1)
  }), 0)]), _vm._v(" "), _c('b-col', [_c('div', {
    staticClass: "setting__container"
  }, [_c('div', {
    staticClass: "password-change-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "text-form",
    attrs: {
      "type": "password",
      "placeholder": "現在のパスワード",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "text-form",
    attrs: {
      "type": "password",
      "placeholder": "新しいパスワード",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "text-form",
    attrs: {
      "type": "password",
      "placeholder": "新しいパスワード(確認用)",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "setting__button",
    on: {
      "click": function($event) {
        return _vm.onChangePassword()
      }
    }
  }, [_vm._v("パスワード変更")])])])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "setting-footer"
  }, [_c('b-col', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('p', {
    staticClass: "setting__alert-message"
  }, [_vm._v(_vm._s(_vm.categoryAlertMessage))])]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "md": "3"
    }
  }, [_c('button', {
    staticClass: "setting__button",
    on: {
      "click": function($event) {
        return _vm.categoryConfirm()
      }
    }
  }, [_vm._v("更新")])]), _vm._v(" "), _c('b-col', [_c('button', {
    staticClass: "setting__button",
    on: {
      "click": function($event) {
        return _vm.onLogout()
      }
    }
  }, [_vm._v("ログアウト")])])], 1)], 1)])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ac3e14","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./src/components/aftersale/setting/setting.html
// module id = 712
// module chunks = 0